<template>
  <div class="card border-primary">
    <div v-if="title" class="card-header bg-primary text-white">
      {{ title }}
    </div>

    <div class="card-body">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',

  props: ['title']
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Card.vue